const FAQS = [
  {
    id: 'home-faq-grupos',
    question: '¿Cuántos estudiantes hay por grupo?',
    answer: 'Mantenemos grupos de aproximadamente 10 estudiantes por grado, lo que permite ofrecer una educación más personalizada y un seguimiento cercano.'
  },
  {
    id: 'home-faq-materiales',
    question: '¿Qué materiales necesita mi hijo?',
    answer: 'Trabajamos con currículo digital Edusystem, complementado con materiales educativos adicionales según necesidades.'
  },
  {
    id: 'home-faq-bilingue',
    question: '¿El programa es completamente en inglés?',
    answer: 'Nuestro programa es bilingüe, integrando inglés y español.'
  },
  {
    id: 'home-faq-diagnosticos',
    question: '¿Solo aceptan niños con diagnósticos?',
    answer: 'No. Aceptamos estudiantes regulares y aquellos que necesiten apoyo individualizado.'
  },
  {
    id: 'home-faq-horario-reducido',
    question: '¿Por qué el horario es reducido?',
    answer: 'Priorizamos calidad sobre cantidad, con enfoque en aprendizaje efectivo y desarrollo integral.'
  },
  {
    id: 'home-faq-verano',
    question: '¿Ofrecen servicios durante el verano?',
    answer: 'Actualmente no contamos con programa de verano.'
  },
  {
    id: 'home-faq-cuido',
    question: '¿Ofrecen cuido extendido?',
    answer: 'Actualmente no contamos con este servicio.'
  }
];

export const HomeFaqs = () => (
  <section className="py-20 md:py-28 bg-white" data-testid="home-faq-section">
    <div className="max-w-4xl mx-auto px-6 sm:px-8 md:px-12">
      <div className="text-center mb-12">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">Preguntas Frecuentes</span>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-4">
          Lo que las familias quieren saber
        </h2>
        <p className="text-base text-stone-700 max-w-2xl mx-auto">
          Respuestas claras a las preguntas más comunes sobre nuestro programa educativo.
        </p>
      </div>

      <div className="space-y-4">
        {FAQS.map((faq) => (
          <details
            key={faq.id}
            className="bg-[#F3F0EA] rounded-2xl shadow-sm border-l-4 border-[#d3b163] group"
            data-testid={faq.id}
          >
            <summary className="px-6 py-5 cursor-pointer font-semibold text-stone-900 flex justify-between items-center list-none">
              <span>{faq.question}</span>
              <span className="text-[#d3b163] text-2xl font-light group-open:rotate-45 transition-transform">+</span>
            </summary>
            <p className="px-6 pb-5 text-base text-stone-700 leading-relaxed">
              {faq.answer}
            </p>
          </details>
        ))}
      </div>
    </div>
  </section>
);
